import React from "react";
import Link from "next/link";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarGroupLabelIcon,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@src/lib/ui/Sidebar";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@src/lib/ui/Collapsible";
import BookOpenOutlineIcon from "@src/lib/icons/18px/book-open-outline";
import { useRouter } from "next/router";
import { useBooleanLocalStorage } from "@src/lib/hooks/useLocalStorage";
import AdminLeftNavTaskListMenuButton from "./AdminLeftNavTaskListMenuButton";
import SuitcaseOutlineIcon from "@src/lib/icons/18px/suitcase-outline";
import { useFeatureFlag } from "@src/features/app/hooks/useFeatureFlag";
import { Ff } from "@src/types.generated";

const LIBRARY_FILTER_PATHS = ["/library"];

const AdminLeftNavLibraryMenu: React.FC = () => {
  const { pathname } = useRouter();
  const { state } = useSidebar();
  const scormEnabled = useFeatureFlag(Ff.ScormResources);
  const [isOpen, setIsOpen] = useBooleanLocalStorage(
    `admin-left-nav-library-menu-open`,
    true,
  );

  const libraryIsActive = LIBRARY_FILTER_PATHS.includes(pathname);

  return (
    <Collapsible
      asChild
      open={state === "collapsed" ? true : isOpen}
      onOpenChange={setIsOpen}
      className="group/collapsible"
    >
      <SidebarGroup>
        <SidebarGroupLabel asChild>
          <CollapsibleTrigger>
            Library
            <SidebarGroupLabelIcon />
          </CollapsibleTrigger>
        </SidebarGroupLabel>
        <CollapsibleContent>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  tooltip="Training"
                  data-testid="library-button"
                  isActive={libraryIsActive}
                >
                  <Link href="/library">
                    <BookOpenOutlineIcon />
                    Training
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              {scormEnabled && (
                <SidebarMenuItem>
                  <SidebarMenuButton
                    asChild
                    tooltip="SCORM"
                    data-testid="scorm-courses-button"
                    isActive={pathname === "/library/scorm-courses"}
                  >
                    <Link href="/library/scorm-courses">
                      <SuitcaseOutlineIcon className="size-[18px]" />
                      SCORM
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              )}
              <AdminLeftNavTaskListMenuButton />
            </SidebarMenu>
          </SidebarGroupContent>
        </CollapsibleContent>
      </SidebarGroup>
    </Collapsible>
  );
};

export default AdminLeftNavLibraryMenu;
